import "./UserDetails.css";
import Navbar from "../components/Navbar/Navbar";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import UserDetailsCard from "./UserDetailsCard";
import { User } from "../models/user";
import { apiCall } from "../api/apiCall";
import TopHeader from "../components/Navbar/TopHeader";
import { useTranslation } from "../i18n/UseTranslation";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";

function UserDetails({ showNavbar = true }: { showNavbar?: boolean }) {
  const { t } = useTranslation();
  const { firebaseUid } = useParams<{ firebaseUid: string }>();
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthReady(true);
    });
    return () => unsubscribe();
  }, []);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["userDetails", firebaseUid],
    queryFn: async () => {
      return await apiCall<User>(`/users/${firebaseUid}`);
    },
    enabled: isAuthReady && !!firebaseUid,
  });

  if (isLoading)
    return (
      <div>
        {showNavbar && <Navbar />}
        <TopHeader />
        <p className="user-loading">{t.users.loading}</p>
      </div>
    );

  if (isError || !data)
    return (
      <div>
        {showNavbar && <Navbar />}
        <TopHeader />
        <p className="user-error">
          {isError
            ? `${t.users.errorLoading} ${(error as Error).message}`
            : t.users.notFound}
        </p>
      </div>
    );

  return (
    <div className="user-details-main-container">
      {showNavbar && <Navbar />}
      <TopHeader />
      <div className="user-page-wrapper">
        <UserDetailsCard user={data} />
      </div>
    </div>
  );
}

export default UserDetails;
